import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueLocalStorage from 'vue-local-storage'
import VeeValidate from 'vee-validate'
import Vue2Filters from 'vue2-filters'
import router from './router'
import Config from './config'
import Webservice from './webservice'
import Util from './util'
import Simplert from 'vue2-simplert-plugin'

import VueAnalytics from 'vue-analytics'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import App from './App'
import VueMask from 'v-mask'

var SocialSharing = require('vue-social-sharing');
 
Vue.use(SocialSharing);


Vue.use(VueMask);

Vue.config.productionTip = true

Vue.use(VueCookie)
Vue.use(VueLocalStorage)
Vue.use(VeeValidate)
Vue.use(Vue2Filters)
Vue.use(Config)
Vue.use(Webservice)
Vue.use(Simplert)

if (location.hostname === 'labotist.com') {
  Vue.use(VueAnalytics, {
    id: 'UA-110171773-1',
    router
  })
} else if (location.hostname === 'stage.labotist.com') {
  Vue.use(VueAnalytics, {
    id: 'UA-118689077-1',
    router
  })
} else if (location.hostname === 'dev.labotist.com') {
  Vue.use(VueAnalytics, {
    id: 'UA-118672795-1',
    router
  })
}
Vue.use(VueFacebookPixel)
// Vue.analytics.fbq.init('162958627765177',{
//   em: 'kabildev12@gmail.com'
// })

router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  
  if(!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));
  
  next()
})
const LoadingComponent = Config.IsMobile ? { template: `<div class="loading">
            <div class="loading-img">
                <img src="static/images/icon/loading.gif" alt="">
            </div>
        </div>` } : 
        { template: `<div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>` }
const AsyncApp = () => ({
  component: new Promise((resolve) => {
    setTimeout(() => {
      resolve(App)
    }, 1000)
  }),
  loading: LoadingComponent
})
export default new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    'App': AsyncApp
  },
  async beforeCreate () {
    await this.$clientToken().then(function(){
      this.$root.$emit('isLogin', true)
    }.bind(this))
  }
})



// WEBPACK FOOTER //
// ./src/main.js